export const SDK_NAME = "sentry.javascript.miniapp";
export const SDK_VERSION = "0.1.0";
